module.exports = __webpack_public_path__ + "static/media/ReefCafeLogo.c06b63e2.svg";